import { Language } from "i18n/util"
import { useShop } from "./useShop"

export function useLanguage(): Language {
  const shop = useShop()

  return (shop?.language || "de") as Language
}
